export const CHART_COLUMNS = [
  {
    label: '24 Hours',
    content: (
      <>
        <h3>Wear your top bandage</h3>
        <p>The compression bandage helps minimize bruising.</p>
      </>
    ),
  },
  {
    label: '3-5 Days',
    content: (
      <>
        <h3>Keep your implant site covered</h3>
        <p>
          While the insertion site is healing, keep the area covered with a
          smaller bandage.
        </p>
      </>
    ),
  },
];
